import Resources from "./resources.js";
import Configuration from "./configuration.js";
import axios from "axios";
import store from "../store/index.js";

export default class DataServices {
    responseData = [];

    constructor() {
      this.resource = new Resources();
      this.config = new Configuration();
    }
    async callWithPostWithoutToken(url, data) {
        await axios
        .post(this.resource.BACKEND_SIDE_BASE_URL + url, data)
        .then((response) => (this.responseData = response.data))
        .catch(error => {throw error});
        return this.responseData;
    }
    async retrieveWithGet(url) {
        const token = store.state.token;
        const configHeader = {
            headers: {
                Authorization: `Bearer ${token}`,
                userid: store.state.userID
            },
        };
        await axios
        .get(this.resource.BACKEND_SIDE_BASE_URL + url, configHeader)
        .then((response) => (this.responseData = response.data))
        .catch(error => {throw error});
        return this.responseData;
    }
    async callWithPost(url, data) {
        const token = store.state.token;
        if (!token) {
            throw new Error('Token not found');
        }
        const configHeader = {
            headers: {
                Authorization: `Bearer ${token}`,
                userid: store.state.userID
            }
        };
        await axios
        .post(this.resource.BACKEND_SIDE_BASE_URL + url, data, configHeader)
        .then((response) => (this.responseData = response.data))
        .catch(error => {throw error});
        return this.responseData;
    }
    async updateWithPut(url, data) {
        const token = store.state.token;
        if (!token) {
            throw new Error('Token not found');
        }
        const configHeader = {
           headers: {
                Authorization: `Bearer ${token}`,
                userid: store.state.userID
           },
        };
        await axios
        .put(this.resource.BACKEND_SIDE_BASE_URL + url , data, configHeader)
        .then((response) => (this.responseData = response.data))
        .catch(error => {throw error});
        return this.responseData;
    }
    async downloadFileWithGet(url, data){
        const token = store.state.token;
        await axios
        .get(this.resource.BACKEND_SIDE_BASE_URL + url, {
            responseType: 'blob',
            params: data,
            headers: {
                Authorization: `Bearer ${token}`,
                userid: store.state.userID
            }
        })
        .then((response) => (this.responseData = response))
        .catch(error => {throw error});
        return this.responseData;
    }
}
